import * as Sentry from "@sentry/browser";
import {Dedupe, ExtraErrorData} from "@sentry/integrations";
import {Integrations} from "@sentry/tracing";
import { getRuntimeConfig } from "./runtimeConfig";

export function initSentry() {
  const runtimeConfig = getRuntimeConfig()
  if (!import.meta.env.DEV && runtimeConfig.sentryDsn) {
    Sentry.init({
      environment: runtimeConfig.sentryEnvironment ?? 'production',
      dsn: runtimeConfig.sentryDsn,
      release: runtimeConfig.sentryRelease,
      integrations: [new Integrations.BrowserTracing(), new ExtraErrorData(), new Dedupe()],
    })
  }
}
